<div class="alert" [class.visible]="isVisible" *ngIf="isVisible">Your internet connection is unstable</div>
